import { useRef } from 'react';
import { TheirInductionFragment } from '@graphqlTypes';
import { Container, VideoPlaylist, VideoSingular, HeadlineAnim, RevealWrapper } from '@components';
import { getHighlightMarkup } from '@/core/utils';

import { useViewSize } from '@/providers/ViewSizeContext';
import { useInView } from 'motion/react';
import { AnimVals } from '@/utils/animUtils';

import styles from './InducteeInductionHero.module.scss';
import className from 'classnames/bind';
const cx = className.bind(styles);

type InducteeInductionHeroProps = TheirInductionFragment['inducteeData']['inductionHero'];

export default function InducteeInductionHero(props: InducteeInductionHeroProps) {
  const { headline, singleVideo, videoPlaylist, type } = props;
  const isSingle = type[0] === "single-video";
  const headlineMarkup = getHighlightMarkup(headline);

  // -------------------- Animation

  const rootEl = useRef<HTMLDivElement>(null);
  const { isDesktop } = useViewSize();
  const REVEAL = AnimVals;
  const triggerPercent = isDesktop ? REVEAL.lg.triggerPercent : REVEAL.sm.triggerPercent;
  const isInView = useInView(rootEl, { amount: triggerPercent, once: REVEAL.once });

  // -------------------- Render

  return (
    <section className={cx('inductee-induction-hero')} ref={rootEl}>
      <RevealWrapper isInView={isInView}>
        <Container className={cx("container-top")}>
          <div className={cx("headline-wrap")}>
            <HeadlineAnim
              tag="h3"
              text={headlineMarkup}
              className={cx(["title-uc-xxxxl", "headline"])}
              isRevealEnabled={false}
              isInView={isInView}
            />
          </div>
        </Container>
        <div className={cx("video-container")}>
          {isSingle ? (
            <VideoSingular {...singleVideo} detail={true} />
          ) : (
            <VideoPlaylist {...videoPlaylist} />
          )}
        </div>
      </RevealWrapper>
    </section>
  );

}
